import React from "react";
import { Grid, Typography, Box, Container, Link } from "@mui/material";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";

const ContactUs = () => {
  return (
    <JumboCardQuick wrapperSx={{ pt: 0 }}>
      <Container maxWidth="md">
        <Box py={4}>
          <Typography variant="h4" align="center" fontWeight={600} gutterBottom>
            Contact Us
          </Typography>

          <Grid container spacing={3} justifyContent="center">
            <Grid item xs={12}>
              <Box textAlign="center">
                <Typography variant="h6" gutterBottom fontWeight={600}>
                  You can reach us at{" "}
                  <Link href="mailto:sai@codingpal.org" underline="hover">
                    sai@codingpal.org
                  </Link>{" "}
                  by dropping an email.
                </Typography>

                <Typography variant="h6" gutterBottom fontWeight={600}>
                  We usually get back within 48-72 hours.
                </Typography>

                <Typography variant="h6" gutterBottom fontWeight={600}>
                  Phone Number: +91 8143450599
                </Typography>

                <Typography variant="h6" gutterBottom fontWeight={600}>
                  Address: CodingPal Learning Solutions LLP, 5th floor,
                  Radhika's Avasa, Miyapur, KV Rangareddy, Telangana, 500049
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </JumboCardQuick>
  );
};

export default ContactUs;
